import iframeEmbeddingTypes from '../constants/iframe-embedding-types';
import getElementAttributes from './get-element-attributes';
import excludeAttributes from './exclude-attributes';

const ignoredAttributes = ['class', 'frameborder', 'loading'];

function getInitialIframeEmbeddingType(element) {
  const currentAttributes = getElementAttributes(element);
  const filteredAttributes = excludeAttributes(currentAttributes, ignoredAttributes);
  const attributes = Object.keys(filteredAttributes);

  if (attributes.length === 1 && attributes.includes('src')) {
    return iframeEmbeddingTypes.URL;
  }

  if (
    attributes.length === 2 &&
    attributes.includes('src') &&
    attributes.includes('allowfullscreen')
  ) {
    return iframeEmbeddingTypes.URL;
  }

  return iframeEmbeddingTypes.CODE;
}

export default getInitialIframeEmbeddingType;
